<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template  v-slot:activator="{ on }">
        <span class="tw-w-full tw-px-4">{{ pre }} Read the <a @click.prevent="" v-on="on" class="tw-underline">Terms and Conditions</a> and our <a href="https://bit.ly/3XGejwr" :title="linkTitle" target="_blank" class="tw-underline">Privacy Policy</a>  {{ post }}</span>
      </template>
      <v-card>
        <v-card-title>
          <span class="c-blue-text tw-font-bold" style="text-align: left;">Terms And Conditions</span>
        </v-card-title>
        <v-card-text>
      <br>
      <strong>General</strong> <br><br>
      These terms and conditions  of use are between you, whether personally or on behalf of an entity ("you") and Pacis Insurance Company Limited,
      a private limited liability company incorporated in Kenya with registration number C. 100942 of P.O. Box 1870-00200, Nairobi, Kenya and
      located at Pacis Centre, Waiyaki Way, Nairobi, Kenya ("Pacis", "we," "us" or "our"), concerning your access to and use of our
      mobile application (the "Application").
      Please read these Terms carefully before you click the "I accept the Terms" button.<br><br>

      <strong>Binding Terms</strong> <br><br>
      Your access and use of the Application constitutes your agreement to be bound by these Terms, which establishes a contractual relationship between
      you and Pacis. If you do not agree to these Terms, you may not access or use the Application. These Terms expressly supersede prior agreements or arrangements with you.
      Pacis may amend these Terms related to the Application from time to time.  Amendments will be effective upon Pacis posting of such updated Terms at
      this location or the amended policies or supplemental terms on the Application. Your continued access or use of the Application after such
      posting constitutes your consent to be bound by the Terms, as amended.<br><br>

      <strong>User Accounts</strong> <br><br>
      Prior to using the Application, you must sign up by providing the requested information (including your name, contact information, email address,
      KRA PIN number) in the "Sign Up" and upload necessary information as required by us. Upon the successful completion of the Sign-Up we will
      provide you with a personal account via a username and password.
      By clicking the Sign Up button located on the sign up application, you represent and warrant that:
      <ol>
      <li> you are above the age of eighteen (18) years; </li>
      <li> you shall not install or use the Application on a jail-broken or rooted device; </li>
      <li> all the information you have presented to us is accurate, correct and complete;</li>
      <li> you will keep your account accurate and profile information updated at all times; </li>
      <li> you will not authorize other persons to use your account nor transfer or assign it to any other person;</li>
      <li> you will not use the Application for unauthorized or unlawful purposes and impair the proper operation of the Application;</li>
      <li> remove any copyright, trademark or other proprietary notices from any portion of the Application;</li>
      <li> reproduce, modify, distribute, license, sell, transfer, transmit, or otherwise exploit the Application except as expressly permitted by Pacis;</li>
      <li> decompile, reverse engineer or disassemble the Application except as may be permitted by applicable law;</li>
      <li> transmit files that contain viruses, corrupted files, or any other programs that may damage or adversely affect the operations of the Application; or
      <li> attempt to gain unauthorized access to or impair any aspect of the Application or its related systems or networks.</li>
      </ol>
      We however reserve the right to limit the use of the Application and/or terminate or suspend abusive user's accounts. <br><br>
      <strong>Services</strong><br><br>
      The Application constitutes an interactive technology platform that enables users of the Application to access Pacis insurance services in a
      fast and convenient way even when you are out and about.
      The following actions and services can be performed by you when you "Log In" into the Application:
      <ol>
      <li> register to become an Pacis customer;</li>
      <li> chat with us;</li>
      <li> Schedule your valuation;</li>
      <li> view existing policies with Pacis;</li>
      <li> get quotations;</li>
      <li> purchase an insurance policy;</li>
      <li> renew existing policy (applicable to Motor Policies);</li>
      <li> make payments through the Application (including premiums, excess);</li>
      <li> submit a claim (applicable to Motor Policies);</li>
      <li> get notifications on all updates regarding your policies and claims (applicable to Motor Policies); and</li>
      <li> any other actions and services that may be added to the Application by Pacis from time to time,
      (with the services referred to in (a) to (n) above collectively being referred to as the "Services").</li>
      </ol><br>

      <strong>Licence</strong> <br><br>
      Subject to your compliance with these Terms, Pacis grants you a limited, non-exclusive, non-sub licensable, revocable, non-transferrable license to:<br>

      a) access and use the Application on your personal device solely in connection with accessing the Services;<br>
      b) access and use any content, information and related materials that may be made available through the Application, in each case solely for your personal, non-commercial use.<br>
      Any rights not expressly granted herein are reserved by Pacis and Pacis's licensors.
      Who can use the Application?
      This Application is accessible to:<br>
      a. users who are at least 18 years' old; and<br>
      b. the general public within the republic of Kenya.<br>
      We however reserve the right to right to limit the use of the Application and/or terminate or suspend abusive users' accounts.<br><br>

      <strong>Compatible Devices</strong><br><br>
      The Application works on Android 4.3 and above (we working on updating and expanding usable devices).
      What does it cost?
      Using the Application is free of charge.
      You are responsible for obtaining the data network access necessary to use the Application. Your mobile network's data and messaging rates and fees may
       apply if you access or use the Application from a wireless-enabled device and you shall be responsible for such rates and fees.
      You are responsible for acquiring and updating compatible hardware or devices necessary to access and use the Application and any updates thereto.
      Pacis does not guarantee that the Application, or any portion thereof, will function on any particular hardware or devices.
      In addition, the Application may be subject to malfunctions and delays inherent in the use of the internet and electronic communications.
      Third Party Services and Content
      The Application may be made available or accessed in connection with third party services such as Google Inc., and content (including advertising)
       that Pacis does not control. You acknowledge that different terms of use and privacy policies may apply to your use of such third party services and content.
      Pacis does not endorse such third party services and content and in no event shall Pacis be responsible or liable for any products or
      services of such third party providers. These third party beneficiaries are not parties to these Terms and are not responsible
      for the provision or support of the Application in any manner. Your access to the Application using these devices owned by third
      parties is subject to terms set forth in the applicable third party beneficiary's terms of service.
      You acknowledge that you shall be responsible for any charges or fees payable to third party arrangements.<br><br>

      <strong>PRIVACY</strong><br><br>
      All information collected from users of our sites is subject to our Privacy Policy, which is incorporated
      by reference into these Terms. For more information, see our Privacy Policy.
      It is your responsibility to maintain the security and privacy of your account information,
      including your username, password, and email identification.  You are responsible for any
      activity that occurs on your account for any reason. If you have reason to believe
      that your account has been accessed without your authorization, you must notify us immediately.
      For your protection, if we believe that any unauthorized access may occur or
      has occurred, we may terminate such access without prior notice to you.
      You also agree that we are permitted to act upon any instructions received
      using your username and password and to consider such instructions as authorized by you.
      App Push Notifications include your transaction details, which will appear
      on the notification icon screen of your mobile device unless you change its settings.
      Updates to the Application
      If we need to change anything about the Application, we will tell you about the
      change in advance (if it negatively affects how you use the Application) or we
      will tell you after we make the change (if it benefits you or doesn't affect
      how you use the app). We'll send you a text, alert or display a message about the
      change when you next use the Application or log into our website. If there's
      anything we need you to consent to, we might ask you to read and accept a message
      on your screen to continue using the Application.
      From time to time, we may update the Application through the Google Play
      Store to improve performance, enhance functionality, reflect changes to
      the operating system or address security issues. Depending on what the
      update is, you may not be able to use the Application until you have
      installed the latest version and accepted the new information about
      it. We will let you know via your phone or when there's a new version to upload.
      You may have to update your device(s) to access the Application in
      compliance with the standards and requirements we shall communicate from time to time.<br><br>

      <strong>Ownership</strong><br><br>
      The Application and all rights therein are and shall remain Pacis's property or the
      property of Pacis's licensors. Neither these Terms nor your use of the Application
      convey or grant to you any rights:<br>
      a) in or related to the Application except for the limited license granted above; or<br>
      b) to use or reference in any manner Pacis's company names, logos, product
      and service names, trademarks or services marks or those of Pacis's licensors.<br><br>

      <strong>Term and Termination</strong><br><br>
      The Terms specified herein shall enter into force as of the date of submitting the Sign Up application.
      Pacis may be entitled to immediately terminate these Terms and block your access to the Application without
      giving any advance notice in case you breach these Terms, any applicable laws or regulations, disparage
      Pacis, or cause harm to Pacis's brand, reputation or business as determined by Pacis in our sole discretion.
      In the aforementioned cases we may, at our own discretion, prohibit you from registering a new account.<br><br>

      <strong>Contacting you</strong><br><br>
      We may contact you by email, text or other messages on the Application, or by telephone or post to update you on
      any changes regarding the Application or our policy.
      We may send marketing messages. If you don't wish to receive them, you may inform us at any time by contacting
      us on our normal contact number.
      Your digital statement may include notices that we are required to give you, such as premium in arrears and
      information about changes to your terms and conditions and premium rate.
      We may still sometimes send communications by post, for example, notices about a breach of your agreement.
      This may be instead of, or in addition to, communications by electronic means.
      It is important that you keep us updated with any changes to your contact details.<br><br>

      <strong>Disclaimer</strong><br>
      Our Application and Services are provided "as is" and "as available." Pacis disclaims all representations
      and warranties, express, implied or statutory, not expressly set out in these terms, including the implied
      warranties of merchantability, fitness for a particular purpose and non-infringement.
      In addition, Pacis makes no representation, warranty, or guarantee regarding the reliability, timeliness,
      quality, suitability or availability of the services requested through the use of the Application, or that
      the services provided through the Application will be uninterrupted or error-free. Pacis does not guarantee
      the quality, suitability, safety or ability of third party providers.
      You agree that the entire risk arising out of your use of the Application, and any service requested in
      connection therewith, remains solely with you, to the maximum extent permitted under applicable law.<br><br>

      <strong>Limitation of Liability</strong><br><br>
      Pacis shall not be liable for indirect, incidental, special, exemplary, punitive or consequential damages,
      including lost profits, lost data, personal injury or property damage related to, in connection with, or
      otherwise resulting from any use of the Application, even if Pacis has been advised of the possibility of such damages.
      Pacis shall not be liable for any damages, liability or losses arising out of:<br>
      a) your use of or reliance on the Application or your inability to access or use the Services; or <br>
      b) any transaction or relationship between you and any third party provider, even if Pacis has been advised
      of the possibility of such damages.
      Pacis shall not be liable for delay or failure in performance resulting from causes beyond Pacis's reasonable control.
      The limitations and disclaimer in this section do not purport to limit liability or alter your rights
      as a consumer that cannot be excluded under applicable law.
      Policies issued through the application are governed by the principles of insurance.
      Accepting our terms and conditions confirms that no other insurance company – has declined your
      proposal, cancelled or refused to renew your policy, required to increase premium or imposed
      special conditions or required you to carry the first amount of any loss.<br><br>

      <strong>Assignment</strong><br><br>
      We may assign or transfer our rights under these Terms to another entity (but Pacis will always notify
      you in writing by posting on this on the Application).
      You shall not transfer or assign your rights or your obligations under these Terms to another person.
      Governing laws
      Except as otherwise set forth in these Terms, these Terms shall be exclusively be construed in accordance
      with the laws of Kenya.
      Dispute Resolution
      The parties will attempt in good faith to negotiate a settlement to any dispute or differences
      between them arising out of or in connection with this Terms within twenty (20)
      business days of either party notifying the other of the dispute or differences. Nothing in this
      dispute resolution procedure will prevent the disputing parties from seeking from any court of
      competent jurisdiction an interim order restraining the other party from doing any act or compelling
      the other party to do any act. If the dispute cannot be resolved by the disputing parties, the dispute
      shall be referred to and finally determined by arbitration in accordance with the Kenya Arbitration Act
      1995 and the Rules of the Kenya branch of the Chartered Institute of Arbitrators, which Rules are deemed
      to be incorporated in this Agreement. The arbitration shall take place at such venue as the disputing parties
      shall agree. The arbitration proceedings shall be conducted by one arbitrator appointed by the disputing parties
      failing which by the Chairman for the time being of the Institute of Chartered Arbitrators, Kenya Branch on the
      application of a disputing party. The language of the arbitration shall be English.<br><br>
      <strong>Contact Us</strong><br><br>
      If you have any questions, or you are unhappy with the service, we will appreciate your engagement and feedback. Kindly contact us on <strong>0730 677000</strong>.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">Exit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  props: {
    pre: {
      type: String,
      default: '',
    },
    post: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      linkTitle: '',
      dialog: false,
    };
  },
};
</script>
